import { Box, Typography } from "@mui/material";
import { cardSurfaceSx, portalFont } from "../partnerTheme";

/** Dashed in-edit state when media is expected but still being produced. */
export default function PendingMediaPlaceholder({ message }: { message: string }) {
  return (
    <Box
      sx={{
        ...cardSurfaceSx,
        borderStyle: "dashed",
        borderColor: "rgba(255,255,255,0.18)",
        bgcolor: "transparent",
        minHeight: 200,
        display: "grid",
        placeItems: "center",
        px: 3,
        py: 6,
      }}
    >
      <Typography
        sx={{
          fontFamily: portalFont,
          color: "var(--portal-text-muted)",
          textAlign: "center",
          maxWidth: 420,
          fontSize: "0.9375rem",
          lineHeight: 1.55,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
